// 通用方法和常量

// wxb258928476c24343: 灰度及环境的appid  wx28e21d35bc52763d: 七天网络小学公众号的appid
export const appid = window.location.host.indexOf('7net.cc') !== -1 ? 'wxb258928476c24343' : 'wx28e21d35bc52763d'

export const host = window.location.origin + '/#'

export const $inWeChat = (window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger')

/**
 * @type {Object}
 * @params {name: 参数名称}
 * @description 匹配出微信授权后的地址中间的参数（code or state），
    https://szone-public.septnet.cn/?code=021EuYZv3xdiJU2Qwg2w3p8IAv2EuYZz&state=#/vip?params=1
 */
export function $getQuetyString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  } else {
    return null
  }
}

/**
 * @type {Object}
 * @params {u: 完整的url地址，没有则取href}
 * @description 获取URL上的参数
 */
export function $getUrlParam(u) {
  let url = u || window.location.href
  // url获取，变量声明
  let arrURL = []
  let arrParms = {}
  let key = {}
  let val = {}
  let getURL = {}

  if (url.split('?').length > 1) {
    let sa = url.split('?')
    arrURL = sa[sa.length - 1].split('&')
  }
  // 取值，存入对象
  for (let i = 0; i < arrURL.length; i++) {
    arrParms = arrURL[i].split('=')
    key = arrParms[0]
    val = arrParms[1]
    getURL[key] = decodeURIComponent(val)
  }
  return getURL
}

/**
 * @type {String}
 * @description Date类型转String
 */
export function $formatDate(date, fmt) {
  var o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    'S': date.getMilliseconds() //毫秒
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }

  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
